// extracted by mini-css-extract-plugin
export default {"activationLink":"sVSFgTkiomir156koAwx"};